export default __webpack_public_path__ + "static/media/roobet.9506630b.svg";